import NassauQueue from './NassauQueue';

export default NassauQueue;
